// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_45-6";
export var headerCell = "_45-2";
export var rowWrapper = "_45-4";
export var stickyAggregationCell = "_45-a";
export var stickyAggregationRow = "_45-7";
export var stickyColumnCell = "_45-9";
export var stickyColumnHeaderCell = "_45-8";
export var table = "_45-1";
export var virtualRowWrapper = "_45-5";
export var virtualTableContainer = "_45-0";
export var white = "_45-3";